import {ResponseLettersType} from 'entities';
import type {MessagesType} from 'src/lib/translates/types'
import {APIService, type InstanceApi} from 'services/api/api';
import {APIServiceLetters} from './entities';
import type {GetMessagesParamsType} from '../translates/entities';

class ReastApiServiceLetters implements APIServiceLetters {

    api: InstanceApi | null = null;

    public init(messages?: MessagesType) {
        const api = new APIService({messages})
        this.api = api.getInstanse();
    }

    private getLettersUrl() {
        return `/letters`;
    }

    public async getLetters(params: GetMessagesParamsType): Promise<ResponseLettersType> {
        if (this.api) {
            try {
                const response = await this.api.get<ResponseLettersType>(
                    this.getLettersUrl(),
                    { params },
                );

                return response.data;
            }catch(error) {
                throw Error('ReastApiServiceLetters.getLetters: ' + JSON.stringify(error));
            }
        }
        throw Error('ReastApiServiceLetters.getLetters: axios is broken');
    }
}

export const restApiServiceLetters = new ReastApiServiceLetters()
